export default __webpack_public_path__ + "static/media/IMG_6729 V2 1.cc84927d.jpg";